module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v-tag-editor"
  }, [_c('v-tag-list', {
    attrs: {
      "theme": _vm.theme
    },
    model: {
      value: (_vm.editableTags),
      callback: function($$v) {
        _vm.editableTags = $$v
      },
      expression: "editableTags"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50388b6e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nav1/Tag.vue
// module id = 921
// module chunks = 170